import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ImplantSection: React.FC = () => {
  const { translations } = useLanguage();
  
  return (
    <section className="py-20 bg-white" id="implants">
      <div className="container-custom">
        <div className="grid md:grid-cols-5 gap-12 items-center mb-16">
          <div className="md:col-span-3">
            <p className="mb-6 text-gray-800 text-lg">
              {translations.implants.intro}
            </p>
            <div className="bg-light-gray p-6 rounded-lg">
              <h3 className="text-xl font-bold text-navy mb-4">
                {translations.implants.benefitsTitle || "Vorteile von Implantaten"}
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-light-blue mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">{translations.implants.benefit1 || "Natürliches Aussehen und Gefühl, vergleichbar mit eigenen Zähnen"}</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-light-blue mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">{translations.implants.benefit2 || "Verbesserung der Kaufunktion und Sprechfähigkeit"}</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-light-blue mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">{translations.implants.benefit3 || "Langlebige Lösung mit hoher Erfolgsrate"}</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-light-blue mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">{translations.implants.benefit4 || "Erhalt der Kieferknochenstruktur"}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:col-span-2 relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <div 
                className="aspect-w-3 aspect-h-2 bg-gray-100"
                style={{
                  backgroundImage: "url('/images/seadent-implant.webp')",
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '400px'
                }}
                aria-label="Dental Implants at SeaDent Mallorca"
              ></div>
            </div>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mt-12">
          <div>
            <h2 className="text-2xl font-bold text-navy mb-6">
              {translations.implants.qualityTitle || "Höchste Qualität und Präzision"}
            </h2>
            <p className="mb-6 text-gray-800">
              {translations.implants.quality}
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-navy mb-6">
              {translations.implants.experienceTitle || "Angenehme Behandlungserfahrung"}
            </h2>
            <p className="mb-6 text-gray-800">
              {translations.implants.experience}
            </p>
          </div>
        </div>
        
        <div className="bg-light-gray p-8 rounded-lg mt-16">
          <h3 className="text-2xl font-bold text-navy mb-6 text-center">
            {translations.implants.processTitle || "Der Weg zu Ihren neuen Implantaten"}
          </h3>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 mx-auto flex items-center justify-center text-navy font-bold text-2xl mb-4">1</div>
              <h4 className="font-bold text-navy mb-2">{translations.implants.step1Title || "Beratung"}</h4>
              <p className="text-gray-700">{translations.implants.step1 || "Ausführliches Gespräch und individuelle Planung"}</p>
            </div>
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 mx-auto flex items-center justify-center text-navy font-bold text-2xl mb-4">2</div>
              <h4 className="font-bold text-navy mb-2">{translations.implants.step2Title || "Implantation"}</h4>
              <p className="text-gray-700">{translations.implants.step2 || "Schonender Eingriff unter örtlicher Betäubung"}</p>
            </div>
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 mx-auto flex items-center justify-center text-navy font-bold text-2xl mb-4">3</div>
              <h4 className="font-bold text-navy mb-2">{translations.implants.step3Title || "Einheilung"}</h4>
              <p className="text-gray-700">{translations.implants.step3 || "Verwachsung des Implantats mit dem Kieferknochen"}</p>
            </div>
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 mx-auto flex items-center justify-center text-navy font-bold text-2xl mb-4">4</div>
              <h4 className="font-bold text-navy mb-2">{translations.implants.step4Title || "Zahnersatz"}</h4>
              <p className="text-gray-700">{translations.implants.step4 || "Anfertigung und Einsetzen des individuellen Zahnersatzes"}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImplantSection; 